import React from "react";
import styles from "./spinner.module.scss";
import c from "classnames";

export default function Spinner() {
  return (
    <div className={c(styles.spinner, "inline-block size-10 animate-spin")} />
  );
}
